import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Company } from 'src/app/domains/companies/models';
import { ConnectionDetails, ConnectionPing, ConnectionStatus } from 'src/app/domains/connectivity/models/connectivity.model';
import { ConnectivityService } from 'src/app/domains/connectivity/services/connectivity.service';

@Component({
  selector: 'gdp-company-connectivity-overview',
  templateUrl: './company-connectivity-overview.component.html',
  styleUrls: ['./company-connectivity-overview.component.scss']
})
export class CompanyConnectivityOverviewComponent implements OnInit {
  public company: Company = null;
  public connectionID: number = null;
  public loading = {
    status: false,
    ping: false
  };
  public connection: ConnectionDetails;
  public connectionStatus: ConnectionStatus;
  public connectionPing: ConnectionPing;

  constructor(
    private connectivityService: ConnectivityService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.parent.data.subscribe(
      (d: { resolved:{ connection: ConnectionDetails, company: Company}} ) => {
        this.connection = d.resolved.connection;
        this.company = d.resolved.company
      }
    );
  }

  public refreshStatus(): void {
    this.loading.status = true;
    this.connectivityService.getConnectionStatus(this.connection.id)
      .subscribe((res: ConnectionStatus) => {
        this.connectionStatus = res;
        this.loading.status = false;
      }, () => {
        this.loading.status = false;
      });
  }

  public goPing(): void {
    this.loading.ping = true;
    this.connectivityService.getConnectionPing(this.connection.id)
      .subscribe((res: ConnectionPing) => {
        this.connectionPing = res;
        this.loading.ping = false;
      }, () => {
        this.loading.ping = false;
      });
  }
}
